<template>
    <div class="filter filter-main">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" v-if="bodyListShow('CAR')">
                <a :class="['nav-link', {active : filterType === 'CAR'}]" role="tab" id="car-tab" data-toggle="tab" href="#cars" aria-controls="cars" @click="changeType('CAR')">Cars</a>
            </li>
<!--            <li class="nav-item" v-if="bodyListShow('LCV')">-->
<!--                <a :class="['nav-link', {active : filterType === 'LCV'}]" role="tab" id="van-tab" data-toggle="tab" href="#vans" aria-controls="vans" @click="changeType('LCV')">Vans</a>-->
<!--            </li>-->
        </ul>
        <div class="tab-content">
            <div v-if="filterType === 'CAR'" :key="'car'" class="tab-pane fade show active" role="tabpanel" aria-labelledby="car-tab">
                <filter-cars ref="carFilter"></filter-cars>
            </div>
            <div v-if="filterType === 'LCV'" :key="'lcv'" class="tab-pane fade show active" role="tabpanel" aria-labelledby="van-tab">
                <filter-vans ref="lcvFilter"></filter-vans>
            </div>
        </div>

        <div class="row">
            <div role="tablist" class="sow-accordion col-12">
                <div :class="['mb-1', 'sow-accordion-panel', {'sow-accordion-panel--open' : financeFilter}]">
                    <div class="p-1 sow-accordion-panel-header" v-b-toggle.finance-filter role="tab" @click="financeFilter=!financeFilter">
                        <div class="sow-accordion-title">
                            <button class="button button--ghost-white">Configure pricing</button>
                            <div class="sow-accordion-open-close-button">
                                <div class="sow-accordion-button sow-accordion-button--open">
                                    <span class="sow-accordion-button__arrow sow-accordion-button__arrow--open"
                                          data-sow-icon=""></span></div>
                                <div class="sow-accordion-button sow-accordion-button--close">
                                    <span class="sow-accordion-button__arrow sow-accordion-button__arrow--close"
                                          data-sow-icon=""></span></div>
                            </div>
                        </div>
                    </div>
                    <BCollapse id="finance-filter" accordion="finance-filter" role="tabpanel">
                        <div class="sow-accordion-panel-content">
                            <div class="row">
                                <div class="col-12 col-md">
                                    <filter-block></filter-block>
                                </div>
                            </div>
                        </div>
                    </BCollapse>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex cta-wrapper">
                <button class="button button--solid" @click="filter()">Search</button>
                <button class="button button--ghost-white" @click="clearFilter(true)">Reset</button>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterCars from "./Filter/FilterCars";
    import FilterVans from "./Filter/FilterVans";
    import FilterBlock from "./FinanceFilter/FilterBlock";

    import {
        SEARCH_RESULTS_PAGE,
        FILTER_BODY,
        FILTER_FUEL_TYPE,
        FILTER_MANUFACTURER,
        FILTER_MODEL,
        FILTER_DATA_MODEL,
        FILTER_TYPE, STATE, FILTER_DATA_MANUFACTURER
    } from "../store/mutation-types";
    import {EXECUTE_FILTER, GET_FUEL_TYPES, GET_MANUFACTURERS} from "../store/action-types";

    export default {
        name: "SearchFilter",
        components: {FilterVans, FilterCars, FilterBlock},
        data: function() {
            return {
                financeFilter: false
            }
        },
        computed: {
            filterType: {
                get: function() {
                    return this.$store.state.FILTER_TYPE;
                },
                set: function(value) {
                    this.$store.commit(FILTER_TYPE, value);
                    this.clearFilter(false);

                    // Removing API look up
                    // Will be hard coded and mapped to actual terms
                    //this.getFuelTypes();
                }
            },
            state: function () {
                return this.$store.state.STATE;
            },
            bodyList: function () {
                return this.$store.state.FILTER_DATA_BODY;
            },
        },
        methods: {
            bodyListShow: function (type) {
                let found = true;

                // only check if a preset manufacturer,
                if (this.$store.state.PRESET_MANUFACTURER) {
                    // loop through each of the types
                    this.bodyList.forEach(function (el) {
                        // if it is the type we are looking for and there is not a length
                        if (el.type === type && el.bodyStyles.length === 0) {
                            // hide the tab control
                            found = false;
                        }
                    });
                }

                // otherwise we will show the tab
                return found;
            },
            changeType(value) {
                this.filterType = value;
                this.$tracking.logStep('Filter', 'SME-Price-List:Filter:ChangeTab:' + this.filterType)
            },
            resetSliders: function() {
                if (this.filterType === 'CAR') {
                    if (this.$refs.carFilter !== undefined) {
                        this.$refs.carFilter.initializeSliders();
                    }
                } else {
                    if (this.$refs.lcvFilter !== undefined) {
                        this.$refs.lcvFilter.initializeSliders();
                    }
                }
            },
            clearFilter: function(button) {
                if(button) {
                    this.$tracking.logStep('Filter', 'SME-Price-List:Filter:Clear');
                    this.$scrollTo('.filter-main');
                }
                this.resetSliders();
                this.$store.dispatch(GET_MANUFACTURERS, []);

                this.$store.commit(FILTER_BODY, []);
                // only reset if we aren't on a preset manufacturer
                if (!this.$store.state.PRESET_MANUFACTURER) {
                    this.$store.commit(FILTER_MANUFACTURER, null);
                    this.$store.commit(FILTER_DATA_MANUFACTURER, null);
                }
                this.$store.commit(FILTER_FUEL_TYPE, null);
                this.$store.commit(FILTER_MODEL, []);
                this.$store.commit(FILTER_DATA_MODEL, []);
                this.$store.commit(STATE, 0);
            },
            filter: function() {
                this.$tracking.logStep('Filter', 'SME-Price-List:Filter:Search');
                let app = this;
                this.$store.commit(STATE, 1);
                this.$store.commit(SEARCH_RESULTS_PAGE, 1);
                this.$store.dispatch(EXECUTE_FILTER, function() {
                    app.$scrollTo('.list-block');
                });
            },
            getFuelTypes: function () {
                this.$store.dispatch(GET_FUEL_TYPES);
            }
        },
        watch: {
            filterType: function() {
                this.clearFilter();
            }
        },
        mounted() {
            if (this.state !== 1) {
                this.filterType = 'CAR';
            } else {
                this.$scrollTo('.list-block');
            }
        }

    }
</script>

<style scoped lang="stylus">
    .filter
        margin-bottom 60px

        .nav
            position relative

    ::v-deep .instruction
        color #4c5356
        font-size 18px
        line-height 18px
        font-family: "VWAGTheSansBold", Arial, sans-serif;
        display block
        margin 35px 0
    ::v-deep .sow-accordion
        margin-bottom 30px
        .sow-accordion-panel
            border-top 1px solid #ecebeb
            &:last-child
                border-bottom 1px solid #ecebeb
            .sow-accordion-panel-header
                cursor pointer
                .sow-accordion-title
                    color #004666
                    font-size 18px
                    line-height 26px
                    padding 26px 0
                    display flex
                    justify-content space-between
                    font-family: "VWAGTheSansRegular", Arial, sans-serif;
                    align-items center

                    .sow-accordion-button--open
                        display none

                    .sow-accordion-open-close-button
                        line-height 1
                        font-size 0

                        .sow-accordion-button
                            color #004666
                            &__arrow
                                display inline-block
                                background url("https://www.vwfsfleet.co.uk/app/themes/vwfs/img/icons/menu-arrow-down.svg") no-repeat #fff 50% 50%
                                width 40px
                                height 25px
                                z-index 10
                                content ''

                                &--close
                                    transform: scaleY(-1);

                &.collapsed
                    .sow-accordion-button--close
                        display none !important

                    .sow-accordion-button--open
                        display block !important
</style>